import axios from '@/axiosInstance'
import {z} from 'zod'

/**
 * Get Tax code
 */
export const HttpGetTaxCodePayload = z.object({
    firstName: z.string(),
    lastName: z.string(),
    gender: z.string(),
    birthDate: z.string(),
    birthCountryId: z.string(),
    birthCityId: z.string().nullable()
})
export type HttpGetTaxCodePayload = z.infer<typeof HttpGetTaxCodePayload>

export const httpGetTaxCode = (payload: HttpGetTaxCodePayload) => axios.post(`/tax-codes`, payload)
